// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_ULc","cls2":"WorkCard-cls2_d-R WorkCard-cls1_ULc"};